<template>
    <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
      <span class="mouse-pointer" v-if="params.Count > 0" @click="filterAttendeeListByLocationId(params.LocationId)">{{ params.Count }}</span>
      <span v-else>0</span>
    </div>
  </template>

  
  <script>
  // Mixins
  import commonMixin from '@/mixins/common'
  export default {
    name: "CellRendererActions",
    mixins: [commonMixin],
    data (){
      return {
      }
    },
    methods: {
      filterAttendeeListByLocationId(locationId){
        if(locationId){
          this.$router.push({ path: '/event/attendees', query: { locId: locationId }});
        }
      }
    },
  };
  </script>
  